import { Question } from '../types/quiz'
import quizData from '../assets/data/quiz_phase2.json'

const NUM_QUESTIONS_PHASE_2 = 5

export const shuffleArray = <T>(arr: T[]): T[] => {
  return arr.sort(() => Math.random() - 0.5)
}

export const getQuestions = (baskets: string[]): Question[] => {
  const questions = []
  for (const basket of quizData) {
    if (baskets.includes(basket.basket)) {
      questions.push(...basket.questions)
    }
  }

  // Shuffle the combined questions
  const shuffled = shuffleArray(questions)

  return shuffled.slice(0, NUM_QUESTIONS_PHASE_2)
}

export const getMostRepeatElement = <T extends string | number | symbol>(
  arr: T[],
): T | null => {
  if (arr.length === 0) return null

  const arr_obj: Record<T, number> = {} as Record<T, number>
  let mostRepeated = arr[0]
  let mostCount = 0

  for (let i = 0; i < arr.length; i++) {
    const el = arr[i]
    if (arr_obj[el] === null) {
      arr_obj[el] = 1
    } else {
      arr_obj[el] += 1
    }

    if (arr_obj[el] > mostCount) {
      mostCount = arr_obj[el]
      mostRepeated = el
    }
  }

  return mostRepeated
}
